import {Component, ApplicationRef} from "@angular/core";

@Component({
  selector: "core-applicationref",
  template: `
  <usecase-container title="ApplicationRef" src="core/applicationref">
    <usecase-content>
      <p>App RootComponent = {{component?.name}}</p>
    </usecase-content>
  </usecase-container>
    `,
})
export class ApplicationRefComponent {
  private component: any = null;

  constructor(private app: ApplicationRef) {
  }

  ngOnInit() {
    this.component = this.app.componentTypes[0];
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/applicationref/component.ts
 **/